// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__238jp","productName":"Table_productName__9dHND"};